import { render, staticRenderFns } from "@/manager/convocation/views/convocationDetail/addNoteModal/addNoteModal.pug?vue&type=template&id=5fb90e34&scoped=true&lang=pug&external"
import script from "./addNoteModal.view.vue?vue&type=script&lang=ts"
export * from "./addNoteModal.view.vue?vue&type=script&lang=ts"
import style0 from "@/manager/convocation/views/convocationDetail/addNoteModal/addNoteModal.scss?vue&type=style&index=0&id=5fb90e34&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb90e34",
  null
  
)

export default component.exports